import React from 'react';
import ReactTable from 'react-table-v6';
import PropTypes from 'prop-types';

function VistaTable(prop) {
    const { data, columns } = prop;
    return (
        <div className="table-responsive-cm  sftp-white-list-table">
            <ReactTable
                filterable
                defaultFilterMethod={(filter, row) =>
                    row[filter.id] !== undefined
                        ? String(row[filter.id]).toLowerCase().includes(filter.value.toLowerCase())
                        : false
                }
                data={data}
                noDataText={'No Data Found'}
                columns={columns}
                sortable={true}
                showPagination={false}
                showPageSizeOptions={false}
                defaultPageSize={data && data.length ? data.length : 4}
                pageSize={data && data.length ? data.length : 1}
                className="-highlight actuals-tab w-100"
            />
        </div>
    );
}

VistaTable.propTypes = {
    data: PropTypes.object,
    columns: PropTypes.object,
    actionText: PropTypes.object
};

export default VistaTable;
